export const Premium50AmpSites = () => {
    return (
        <div>
            premium50amp
        </div>
    )
}